<template>
  <v-container fluid>
    <v-layout wrap justify-space-around>
      <v-flex sm12 lg5>
        <v-card>
          <v-card-title> Productos contratados </v-card-title>
          <v-data-table
            :headers="headersContratados"
            :items="productosContratados"
            :items-per-page.sync="options.itemsPerPage"
            :search="search1"
            v-model="selectedRow"
            :loading="loading"
          >
            <template v-slot:no-data>
              <v-alert :value="true" color="grey" icon="warning">
                No hay items asignados
              </v-alert>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left">{{ item.empresaNombre }}</td>
                <td class="text-xs-left">{{ item.productoDescripcion }}</td>

                <td class="text-xs-left">
                  <v-edit-dialog :return-value.sync="item.fechaAlta">
                    {{
                      item.fechaAlta
                        | dateParse('YYYY-MM-DD')
                        | dateFormat('DD-MM-YY')
                    }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.fechaAlta"
                        label="Edit"
                        single-line
                        counter
                        type="date"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>

                <td class="text-xs-left">
                  <v-icon small class="mr-2" @click="remove(item)">
                    arrow_right
                  </v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" text @click="snack = false"> Close </v-btn>
        </template>
      </v-snackbar>

      <v-flex sm12 lg5>
        <v-card>
          <v-card-title> Productos disponibles </v-card-title>

          <v-data-table
            :headers="headersDisponibles"
            :items="itemsDisponibles"
            :items-per-page.sync="options.itemsPerPage"
            :options.sync="options"
            v-model="selectedRow"
            :loading="loading"
            :search="search2"
          >
            <template v-slot:no-data>
              <v-alert :value="true" color="grey" icon="warning">
                No se encontraron datos
              </v-alert>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left">
                  <v-icon
                    small
                    class="mr-2"
                    @click="
                      showAdd = true;
                      fechaInicio = calcularFechaInicio();
                      itemAContratar = item;
                    "
                    >arrow_left</v-icon
                  >
                </td>
                <td class="text-xs-left">{{ item.descripcion }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showAdd" width="500">
      <v-container fluid>
        <v-card flat>
          <v-card-title> Agregar Afiliación Producto </v-card-title>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                v-model="empresaId"
                :items="empresas"
                autocomplete="disabled"
                item-text="nombre"
                item-value="id"
                label="De la Empresa:"
                placeholder="Seleccione una"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-text-field
                v-model="fechaInicio"
                label="Fecha Inicio"
                type="date"
                prepend-icon="event"
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="green" dark @click="add(itemAContratar)"
              >Confirmar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script>
import { http } from '@/axios';
import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  props: ['value', 'personaId'],
  mounted: function () {},
  activated: function () {
    let selected = this.selectedValues;
    if (selected.length > 0) {
      this.$emit('input', selected);
    }
  },
  deactivated: function () {
    this.$emit('input', []);
  },
  watch: {
    updateProductosContratados() {
      this.$emit('update-productos-contratados', this.productosContratados);
    },
    enabled: {
      handler() {
        if (this.enabled) {
          // limpio la lista de trabajo
        }
      },
    },
  },
  computed: {
    ...mapGetters(['user']),
    selectedValues: function () {
      return this.listItems
        .filter(function (item) {
          return item.selected;
        })
        .map(function (item) {
          return item.value;
        });
    },
    itemsCount: function () {
      return this.items.length;
    },
    selectedCount: function () {
      if (this.value) return this.value.length;
      else return 0;
    },
    itemsDisponibles: function () {
      var list;
      // los disponibles son todos menos los que estan seleccionados
      if (this.productosContratados != null) {
        list = this.productos.filter(
          (e) =>
            !this.productosContratados.find(
              ({ productoDescripcion }) => productoDescripcion === e.descripcion
            )
        );
      } else {
        list = this.productos.filter(
          (p) => p.tipoProductoDescripcion == 'CUPONIZATE'
        );
      }
      return list;
    },
    headersDisponibles() {
      var arr = [];
      arr.push({ text: 'Agregar', value: '', width: 20, sortable: false });

      for (let index = 0; index < this.headersProductos.length; index++) {
        const element = this.headersProductos[index];
        arr.push(element);
      }

      return arr;
    },
    headersContratados() {
      var arr = [];
      for (
        let index = 0;
        index < this.headersProductosContratados.length;
        index++
      ) {
        const element = this.headersProductosContratados[index];
        arr.push(element);
      }
      arr.push({ text: 'Quitar', value: '', width: 20, sortable: false });

      return arr;
    },
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    calcularFechaInicio() {
      // si el dia de hoy es mayor al 21, entonces la fecha de inicio es el primero del mes subsiguiente, si no, el primero del mes siguiente
      var hoy = new Date();
      var dia = hoy.getDate();
      var mes = hoy.getMonth() + 1; //  los genios de js cuentan los meses desde 0
      var anio = hoy.getFullYear();

      if (dia > 21) {
        mes = mes + 1;
      }
      var fechaInicio = new Date(anio, mes, 1);

      fechaInicio = this.$moment(fechaInicio).format('YYYY-MM-DD');
      return fechaInicio;
    },
    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get('productos/'); // traigo todos los productos
        this.productos = result.list.filter(
          (p) => p.tipoProductoDescripcion == 'CUPONIZATE'
        );

        console.log(this.productos);
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.empresas = result.list.filter((x) => x.id == 2);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    add: function (e) {
      if (this.fechaInicio == null) {
        this.alertError('Por favor, indique la fecha de inicio');
        return;
      }

      var itemContratado = {
        fechaAlta: this.fechaInicio,
        productoId: e.id,
        productoDescripcion: e.descripcion,
        empresaId: this.empresaId,
        empresaNombre: this.empresas.find((x) => x.id == this.empresaId).nombre,
      };

      this.showAdd = false;

      this.productosContratados.push(itemContratado);
      this.$emit('update-productos-contratados', this.productosContratados);
    },
    remove: async function (e) {
      let res = await this.$dialog.confirm({
        text: '¿Confirma la baja del Producto "' + e.productoDescripcion + '"?',
        title: 'Desafiliación',
      });

      if (res == false) {
        return;
      }

      this.productosContratados.splice(this.productosContratados.indexOf(e), 1);
      this.$emit('update-productos-contratados', this.productosContratados);
    },
  },
  data: function () {
    return {
      snack: false,
      snackColor: '',
      snackText: '',
      loading: false,
      dialogVisible: false,
      search1: '',
      search2: '',
      flag: false,
      listItems: [],
      listItemsByKey: {},
      filter: '',
      markStart: null,
      selectedRow: [],
      showAdd: false,
      fechaInicio: null,
      itemAContratar: null,
      empresaId: 2,
      empresas: [],
      options: {
        // definición de paginación
        sortDesc: false,
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20, 50],
      },
      productos: [],
      productosContratados: [],
      totalItems: 0,
      headersProductos: [{ text: 'Producto', value: 'descripcion' }],
      headersProductosContratados: [
        { text: 'Empresa', value: 'empresaNombre' },
        { text: 'Producto', value: 'productoDescripcion' },
        { text: 'Fecha de Inicio', value: 'fechaAlta' },
      ],
    };
  },
  async created() {
    this.loadProductos();
    this.loadEmpresas();
    if (this.value != null) {
      this.productosContratados = this.value;
    } else {
      this.productosContratados = [];
    }
    console.log(this.productosContratados);
  },
};
</script>
